// src/app/components/ExpLayout/index.js
import { lazy } from "react";

export const ExpLayouts = {
  layout1: lazy(() => import("./Layout1/Layout1")),
  //	layout2: lazy(() => import("./Layout2/Layout2"))
};
